module.exports = __webpack_public_path__ + "static/media/torah.0435f343.svg";